import React from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import { Typography, Link, Paper, Box } from "@mui/material";

const ErrorPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleGoBack = () => {
        // If there's no navigation history, redirect to the default page
        if (location.key === "default") {
            navigate("/", { replace: true }); // Replace prevents navigating back to 404
        } else {
            navigate(-1); // Go back to the previous path
        }
    };

    return (
        <Box sx={{ 
            height: '100vh', 
            backgroundColor: 'var(--bg-color)',
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
        }}
        >
            <Paper elevation={6} sx={{ 
                padding: 3, 
                margin: 3,
                borderRadius: 2,
                backgroundColor: 'rgba(255,255,255,0.2)',
                width: '-webkit-fill-available',
                maxWidth: '480px'
            }}
            >
                <img src='../assets/page-not-found.svg'
                 alt='page-not-found'/>
                <Typography
                    variant="h5"
                    align="center"
                    color="primary"
                    gutterBottom
                >
                抱歉，您的页面迷路了
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="secondary"
                >
                    我们正在全力搜索中，请点击
                    <Link onClick={handleGoBack}
                        sx={{
                            color: 'primary',
                            textDecoration: "none",
                            marginLeft: 1,
                            '&:hover': {
                                fontWeight: 'bold'
                            }
                        }}
                    >
                        返回首页
                    </Link>
                </Typography>
            </Paper>
        </Box>
    );
  };

export default ErrorPage;